var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    {
      attrs: {
        title: _vm.id === null ? "Cadastrar Professor" : "Editar Professor",
      },
    },
    [
      _c(
        "vs-tabs",
        {
          attrs: { color: _vm.colorx },
          model: {
            value: _vm.tabIndex,
            callback: function ($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex",
          },
        },
        [
          _c(
            "vs-tab",
            { attrs: { label: "Dados Básicos" } },
            [
              _c("TeacherForm", {
                attrs: {
                  services: _vm.services,
                  teacherId: _vm.id,
                  teacherEntity: _vm.teacherEntity,
                },
                on: { "update-data": _vm.handleUpdateDataTeacher },
              }),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Endereço", disabled: _vm.isTabEnabled } },
            [
              _vm.teacherEntity.people_id
                ? _c("Address", {
                    attrs: {
                      services: _vm.services,
                      people_id: _vm.teacherEntity.people_id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Telefone", disabled: _vm.isTabEnabled } },
            [
              _vm.teacherEntity.people_id
                ? _c("Phone", {
                    attrs: {
                      services: _vm.services,
                      people_id: _vm.teacherEntity.people_id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Email", disabled: _vm.isTabEnabled } },
            [
              _vm.teacherEntity.people_id
                ? _c("Email", {
                    attrs: {
                      services: _vm.services,
                      people_id: _vm.teacherEntity.people_id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            {
              attrs: {
                label: "Entidade de classe",
                disabled: _vm.isTabEnabled,
              },
            },
            [
              _vm.teacherEntity.people_id
                ? _c("ClassEntity", {
                    attrs: {
                      services: _vm.services,
                      teacherId: _vm.id,
                      people_id: _vm.teacherEntity.people_id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Modalidades", disabled: _vm.isTabEnabled } },
            [
              _vm.teacherEntity.people_id
                ? _c("Modality", {
                    attrs: {
                      services: _vm.services,
                      serviceDelegate: _vm.services.teacherService,
                      entityId: _vm.id,
                      people_id: _vm.teacherEntity.people_id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Imagens", disabled: _vm.isTabEnabled } },
            [
              _vm.teacherEntity.people_id
                ? _c("Images", {
                    attrs: {
                      serviceDelegate: _vm.services.teacherService,
                      people_id: _vm.teacherEntity.people_id,
                      entityId: _vm.teacherEntity.id,
                      imagesList: _vm.teacherEntity.images,
                      target: "teachers",
                      hint: "Tamanho recomendado: mínimo 600×600px (quadrado ou retrato), rosto centralizado — usada como foto do professor nas páginas de clube e aula.",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }